import {
  Autocomplete,
  Box,
  Button,
  Card,
  Container,
  Divider,
  FormControl,
  FormControlLabel,
  FormGroup,
  FormLabel,
  Grid,
  IconButton,
  InputLabel,
  Link,
  MenuItem,
  Select,
  Switch,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
  styled,
} from '@mui/material';

import CalendarMonthRoundedIcon from '@mui/icons-material/CalendarMonthRounded';
import HandymanRoundedIcon from '@mui/icons-material/HandymanRounded';
import AccountCircleOutlinedIcon from '@mui/icons-material/AccountCircleOutlined';
import TextSnippetRoundedIcon from '@mui/icons-material/TextSnippetRounded';
import DriveFileRenameOutlineOutlinedIcon from '@mui/icons-material/DriveFileRenameOutlineOutlined';
import SolarPowerOutlinedIcon from '@mui/icons-material/SolarPowerOutlined';
import AttachFileRoundedIcon from '@mui/icons-material/AttachFileRounded';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import MyLocationIcon from '@mui/icons-material/MyLocation';
import BlindsClosedIcon from '@mui/icons-material/BlindsClosed';

import React, { useState, useRef, useEffect, useContext, useMemo } from 'react';
import 'react-quill/dist/quill.snow.css';
import { Helmet } from 'react-helmet-async';
import { DatePicker } from '@mui/x-date-pickers';
import ReactQuill from 'react-quill';
import { useParams } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { ZakazkyContext } from '../../services/zakazkyContext';
import { useZakazka } from '../../hooks/useZakazka';
import { Modal, ModalBody } from '../../components/modal/Modal';
import { SectionAccordion, SectionAccordionContent, SectionAccordionTitle } from '../../components/accordion/Accordion';
import Label from '../../components/label/Label';
import Map from '../../components/maps/Map';
import SearchSelect from '../../components/select/SearchSelect';
import PositionPicker from '../../components/maps/PositionPicker';
import ZakazkyForm from '../../sections/@dashboard/zakazky/ZakazkyForm';
import { PartieContext } from '../../services/partieContext';
import { defaultDate } from '../../utils/formatTime';
import dayjs from 'dayjs';
import { useFazy } from '../../hooks/useFazy';
import { switchZakazkaService } from '../../services/zakazkyServices';
import CopyToClipboard from '../../components/clipboard/CopyToClipboard';
import { CloudUploadRounded, DeleteOutlineOutlined, DownloadOutlined } from '@mui/icons-material';

const HTMLEditor = styled(ReactQuill)`
  .ql-container {
    min-height: 10rem;
    height: 100%;
    flex: 1;
    display: flex;
    flex-direction: column;
  }

  .ql-editor {
    height: 100%;
    flex: 1;
    overflow-y: auto;
    width: 100%;
  }
`;

const StyledSwitch = styled(Switch)(({ theme }) => ({
  padding: 8,
  '& .MuiSwitch-track': {
    borderRadius: 22 / 2,
    '&:before, &:after': {
      content: '""',
      position: 'absolute',
      top: '50%',
      transform: 'translateY(-50%)',
      width: 16,
      height: 16,
    },
    '&:before': {
      backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="16" width="16" viewBox="0 0 24 24"><path fill="${encodeURIComponent(
        theme.palette.getContrastText(theme.palette.primary.main)
      )}" d="M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z"/></svg>')`,
      left: 12,
    },
    '&:after': {
      backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="16" width="16" viewBox="0 0 24 24"><path fill="${encodeURIComponent(
        theme.palette.getContrastText(theme.palette.primary.main)
      )}" d="M19,13H5V11H19V13Z" /></svg>')`,
      right: 12,
    },
  },
  '& .MuiSwitch-thumb': {
    boxShadow: 'none',
    width: 16,
    height: 16,
    margin: 2,
  },
}));

const ZaluzieWrapper = styled(Box)`
  display: grid;
  grid-template-columns: repeat(${({ columns }) => columns}, 1fr);
  gap: 2rem;
  margin-top: 20px;
  @media screen and (max-width: 960px) {
    grid-template-columns: repeat(2, 1fr);
    gap: 1rem;
  }
  @media screen and (max-width: 600px) {
    grid-template-columns: repeat(1, 1fr);
    gap: 1rem;
  }
`;

const AbsoluteWrapper = styled(Box)`
  position: absolute;
  right: 20px;
  top: 20px;
`;

const dateformat = (date) => {
  return date ? dayjs(date) : null;
};

const ZakazkyDetail = () => {
  const [mapPosition, setMapPosition] = useState(null);
  const [openPicker, setOpenPicker] = useState(false);

  const { id } = useParams();

  const { zakazka, loading, error } = useZakazka(id);

  const { editZakazka, uploadFiles, removeFile } = useContext(ZakazkyContext);

  const {
    register,
    handleSubmit,
    setValue,
    watch,
    formState: { errors },
  } = useForm();

  const [mapZoom, setMapZoom] = useState(9);
  const mapRef = useRef(null);

  const [zaluzieSwitch, setZaluzieSwitch] = useState(false);
  const [poznamkyZaluzie, setPoznamkyZaluzie] = useState('');

  const zaluzieSwitchHandler = async () => {
    setZaluzieSwitch((prev) => !prev);
    const switchZakazka = await switchZakazkaService(!zaluzieSwitch, 'zaluzie', id);
  };

  const [editor, setEditor] = useState(false);
  const [fotovoltikaSwitch, setFotovoltikaSwitch] = useState(false);
  const [typFotovoltiky, setTypFotovoltiky] = useState('');
  const [hrubaStavbaPartia, setHrubaStavbaPartia] = useState(null);
  const [holodomPartia, setHolodomPartia] = useState(null);

  const [holodomPartiaa, setHolodomPartiaa] = useState(null);
  const [hrubaStavbaPartiaa, setHrubaStavbaPartiaa] = useState(null);
  const [zakladovaDoskaPartia, setZakladovaDoskaPartia] = useState(null);
  const [naKlucPartia, setNaKlucPartia] = useState(null);

  //dates
  const [zakladovaDoskaDate, setZakladovaDoskaDate] = useState(null);
  const [zakladovaDoskaDateEnd, setZakladovaDoskaDateEnd] = useState(null);
  const [hrubovaStavbaDate, setHrubovaStavbaDate] = useState(null);
  const [hrubovaStavbaDateEnd, setHrubovaStavbaDateEnd] = useState(null);
  const [holodomDate, setHolodomDate] = useState(null);
  const [holodomDateEnd, setHolodomDateEnd] = useState(null);
  const [domNaKlucDate, setDomNaKlucDate] = useState(null);
  const [domNaKlucDateEnd, setDomNaKlucDateEnd] = useState(null);
  const [oknaDate, setOknaDate] = useState(null);
  const [oknaDateEnd, setOknaDateEnd] = useState(null);
  const [zaluzieObjednanieDate, setZaluzieObjednanieDate] = useState(null);
  const [zaluzieZamerianieDate, setZaluzieZamerianieDate] = useState(null);
  const [zaluzieMontazDate, setZaluzieMontazDate] = useState(null);
  const [contactPerson, setContactPerson] = useState(null);
  const [opened, setOpened] = useState(false);

  const [edit, setEdit] = useState(false);
  const [lat, setLat] = useState(null);
  const [lng, setLng] = useState(null);

  const { iconSet, statusSet } = useFazy();

  const { partie } = useContext(PartieContext);

  const [files, setFiles] = useState([]);

  const handleFileChange = (event) => {
    const selectedFiles = Array.from(event.target.files);
    setFiles((prev) => [...prev, ...selectedFiles]);
  };
  const handleRemoveFile = (file) => {
    const updatedFiles = files.filter((f) => f !== file);
    setFiles(updatedFiles);
  };

  const handleRemoveFileDatabase = (fileId) => {
    removeFile(id, fileId);
  };

  const getFileNameFromUrl = (url) => {
    const urlParts = url.split('/');
    return urlParts[urlParts.length - 1];
  };

  const handleDownloadFile = (filePath) => {
    const link = document.createElement('a');
    link.href = process.env.REACT_APP_DEV_URL + '/' + filePath;
    link.download = getFileNameFromUrl(process.env.REACT_APP_DEV_URL + '/' + filePath);
    link.target = '_blank'; // Open in a new tab
    link.rel = 'noopener noreferrer'; // Set security attributes
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleSaveFiles = () => {
    uploadFiles(zakazka?.id, files);
  };

  useEffect(() => {
    const fields = [
      'komin',
      'skridla',
      'hydroizolacia',
      'rost',
      'povala',
      'okna',
      'zateplenie',
      'dvere',
      'bojler',
      'vykurovanie',
      'rekuperacia',
      'pristup',
      'zaluziePoznamky',
    ];

    if (zakazka) {
      (zakazka.komin ||
        zakazka.skridla ||
        zakazka.hydroizolacia ||
        zakazka.rost ||
        zakazka.povala ||
        zakazka.okna ||
        zakazka.zateplenie ||
        zakazka.dvere ||
        zakazka.rekuperacia ||
        zakazka.bojler ||
        zakazka.vykurovanie ||
        zakazka.pristup ||
        zakazka.rost) &&
        setEditor(true);
      zakazka.zakladovaDoskaDate && setZakladovaDoskaDate(dateformat(zakazka?.zakladovaDoskaDate));
      zakazka.zakladovaDoskaDateEnd && setZakladovaDoskaDateEnd(dateformat(zakazka?.zakladovaDoskaDateEnd));
      zakazka.hrubovaStavbaDate && setHrubovaStavbaDate(dateformat(zakazka?.hrubovaStavbaDate));
      zakazka.hrubovaStavbaDateEnd && setHrubovaStavbaDateEnd(dateformat(zakazka?.hrubovaStavbaDateEnd));
      zakazka.holodomDate && setHolodomDate(dateformat(zakazka?.holodomDate));
      zakazka.holodomDateEnd && setHolodomDateEnd(dateformat(zakazka?.holodomDateEnd));
      zakazka.oknaDate && setOknaDate(dateformat(zakazka?.oknaDate));
      zakazka.oknaDateEnd && setOknaDateEnd(dateformat(zakazka?.oknaDateEnd));
      zakazka.domNaKlucDateEnd && setDomNaKlucDateEnd(dateformat(zakazka?.domNaKlucDateEnd));
      zakazka.domNaKlucDate && setDomNaKlucDate(dateformat(zakazka?.domNaKlucDate));
      zakazka.zaluzieObjednanieDate && setZaluzieObjednanieDate(dateformat(zakazka?.zaluzieObjednanieDate));
      zakazka.zaluzieZamerianieDate && setZaluzieZamerianieDate(dateformat(zakazka?.zaluzieZamerianieDate));
      zakazka.zaluzieMontazDate && setZaluzieMontazDate(dateformat(zakazka?.zaluzieMontazDate));
      zakazka.holodomPartia && setHolodomPartia(zakazka?.holodomPartia);
      zakazka.holodomPartiaa && setHolodomPartiaa(zakazka?.holodomPartiaa);
      zakazka.hrubaStavbaPartia && setHrubaStavbaPartia(zakazka?.hrubaStavbaPartia);
      zakazka.hrubaStavbaPartiaa && setHrubaStavbaPartiaa(zakazka?.hrubaStavbaPartiaa);
      zakazka.zakladovaDoskaPartia && setZakladovaDoskaPartia(zakazka?.zakladovaDoskaPartia);
      zakazka.naKlucPartia && setNaKlucPartia(zakazka?.naKlucPartia);
      fields.forEach((field) => register(field, { value: zakazka[field] }));
      zakazka.fotovoltika === 'x' && setFotovoltikaSwitch(true);
      zakazka.zaluzie === 'x' && setZaluzieSwitch(true);

      zakazka.contactPerson && setContactPerson(zakazka?.contactPerson);
    }
    setOpened(true);
  }, [register, zakazka]);

  const fieldValues = {
    komin: watch('komin'),
    skridla: watch('skridla'),
    hydroizolacia: watch('hydroizolacia'),
    rost: watch('rost'),
    povala: watch('povala'),
    okna: watch('okna'),
    zateplenie: watch('zateplenie'),
    dvere: watch('dvere'),
    bojler: watch('bojler'),
    vykurovanie: watch('vykurovanie'),
    rekuperacia: watch('rekuperacia'),
    pristup: watch('pristup'),
    zaluziePoznamky: watch('zaluziePoznamky'),
  };

  const onFieldValueChange = (fieldName, editorState) => {
    setValue(fieldName, editorState);
  };

  const fotovoltikaSwitchHandler = async () => {
    setFotovoltikaSwitch((prev) => {
      return !prev;
    });
    const switchZakazka = await switchZakazkaService(!fotovoltikaSwitch, 'fotovoltika', id);
  };

  const typFotovoltikyHandler = (e) => {
    setTypFotovoltiky(e.target.value);
  };

  const mapZoomHandler = (e) => {
    e.preventDefault();
    setMapZoom(19);
    mapRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
  };

  const submitEditZakazka = (data) => {
    const formatDate = (date) => {
      return date ? date.format('YYYY-MM-DD') : date;
    };

    const newData = {
      ...zakazka,
      ...data,
      holodomPartia: holodomPartia?.toString(),
      holodomPartiaa: holodomPartiaa?.toString(),
      hrubaStavbaPartia: hrubaStavbaPartia?.toString(),
      hrubaStavbaPartiaa: hrubaStavbaPartiaa?.toString(),
      naKlucPartia: naKlucPartia?.toString(),
      zakladovaDoskaPartia: zakladovaDoskaPartia?.toString(),
      zakladovaDoskaDate: formatDate(zakladovaDoskaDate),
      zakladovaDoskaDateEnd: formatDate(zakladovaDoskaDateEnd),
      hrubovaStavbaDate: formatDate(hrubovaStavbaDate),
      hrubovaStavbaDateEnd: formatDate(hrubovaStavbaDateEnd),
      holodomDate: formatDate(holodomDate),
      holodomDateEnd: formatDate(holodomDateEnd),
      oknaDate: formatDate(oknaDate),
      oknaDateEnd: formatDate(oknaDateEnd),
      domNaKlucDate: formatDate(domNaKlucDate),
      domNaKlucDateEnd: formatDate(domNaKlucDateEnd),
      zaluzieMontazDate: formatDate(zaluzieMontazDate),
      zaluzieObjednanieDate: formatDate(zaluzieObjednanieDate),
      zaluzieZamerianieDate: formatDate(zaluzieZamerianieDate),
      fotovoltika: fotovoltikaSwitch ? 'x' : '',
      zaluzie: zaluzieSwitch ? 'x' : '',
      contactPerson,
    };

    editZakazka(zakazka?.id, newData);
  };

  const idToPartia = (id) => {
    const partia = partie ? partie.find((partia) => partia.id == id) : null;
    return partia ? partia.contactPerson : '';
  };

  const existingPartie = useMemo(() => (partie ? partie : []), [partie]);

  return (
    <>
      <Helmet>
        <title> Mirano System | Detail zakázky</title>
      </Helmet>

      <Container>
        <Grid mb={4}>
          <Typography variant="h3">Detail zakázky č. {zakazka?.number} </Typography>
          {zakazka ? (
            <Label startIcon={''} sx={{ fontSize: 20, padding: 2 }}>
              {statusSet(zakazka)}
            </Label>
          ) : (
            false
          )}
        </Grid>

        <Card sx={{ p: 3 }}>
          <AbsoluteWrapper>
            <IconButton color="primary" onClick={() => setEdit(true)}>
              <DriveFileRenameOutlineOutlinedIcon />
            </IconButton>
            <Modal
              aria-labelledby="modal-title"
              aria-describedby="modal-desc"
              open={edit}
              onClose={() => setEdit(false)}
              sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}
            >
              <>
                <ZakazkyForm
                  setOpenPicker={setOpenPicker}
                  currentZakazka={zakazka}
                  mapPosition={mapPosition}
                  setMapPosition={setMapPosition}
                  lat={lat}
                  lng={lng}
                  setLng={setLng}
                  setLat={setLat}
                  edit
                />
              </>
            </Modal>
          </AbsoluteWrapper>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={5}>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: 1, marginBottom: 2 }}>
                    <AccountCircleOutlinedIcon />
                    <Typography variant="h4">Klient</Typography>
                  </Box>
                  <Typography sx={{ fontSize: 16 }} color="text.secondary" mb={0.1}>
                    Meno zákazníka
                  </Typography>
                  <Typography sx={{ fontSize: 20 }} mb={2}>
                    {zakazka?.clientName}
                  </Typography>
                  <Typography sx={{ fontSize: 16 }} color="text.secondary" mb={0.1}>
                    Telefonicky kontakt
                  </Typography>
                  <Typography sx={{ fontSize: 20 }} mb={2}>
                    <Link href={`tel:${zakazka?.phone}`}>{zakazka?.phone}</Link>
                  </Typography>
                  <Typography sx={{ fontSize: 16 }} color="text.secondary" mb={0.1}>
                    E-mail
                  </Typography>
                  <Typography sx={{ fontSize: 20 }}>
                    {zakazka?.clientMail ? (
                      <Link href={`mailto:${zakazka?.clientMail}`}>{zakazka?.clientMail}</Link>
                    ) : (
                      '-'
                    )}
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12} sm={7}>
              {/* Second Half */}
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: 1, marginBottom: 2 }}>
                    {' '}
                    <InfoOutlinedIcon />
                    <Typography variant="h4">Základné informácie o stavbe</Typography>
                  </Box>
                  <Typography sx={{ fontSize: 16 }} color="text.secondary" mb={0.1}>
                    Číslo stavby
                  </Typography>
                  <Typography sx={{ fontSize: 20 }} mb={2}>
                    {zakazka?.number}
                  </Typography>
                  <Typography sx={{ fontSize: 16 }} color="text.secondary" mb={0.1}>
                    GPS súradnice
                  </Typography>
                  <Typography sx={{ fontSize: 16 }} mb={1} mt={1}>
                    {zakazka?.lat && zakazka?.lng && (
                      <Box sx={{ display: 'flex', gap: 1 }}>
                        {zakazka?.lat + ', ' + zakazka?.lng} <CopyToClipboard lat={zakazka?.lat} lng={zakazka?.lng} />
                      </Box>
                    )}{' '}
                  </Typography>
                  <Typography sx={{ fontSize: 20 }} mb={2}>
                    <Link href="#map" sx={{ display: 'flex', gap: 1, alignItems: 'center' }} onClick={mapZoomHandler}>
                      {' '}
                      <MyLocationIcon />
                      Zobraz na mape
                    </Link>
                  </Typography>
                  <Typography sx={{ fontSize: 16 }} color="text.secondary" mb={0.1}>
                    Fáza realizácie
                  </Typography>
                  <Typography sx={{ fontSize: 20 }}>{zakazka?.faza ? iconSet(zakazka?.faza, 20) : '-'}</Typography>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Card>
        <Card sx={{ p: 1, mt: 2, mb: 2 }} id="map" ref={mapRef}>
          <Map
            zoom={mapZoom}
            position={{ lat: Number(zakazka?.lat), lng: Number(zakazka?.lng) }}
            disableFilters={true}
          />
        </Card>
        <Card sx={{ p: 1, mt: 2, mb: 2 }}>
          <SectionAccordion>
            <SectionAccordionTitle>
              <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: 1 }}>
                <CalendarMonthRoundedIcon sx={{ fontSize: 30 }} />
                <Typography variant="h4">Dátumy nástupu / ukončenia</Typography>
              </Box>
            </SectionAccordionTitle>
            <SectionAccordionContent>
              {opened && (
                <>
                  <Grid mb={3}>
                    <Typography variant="h6" color="primary" mb={2}>
                      Základová doska
                    </Typography>

                    <DatePicker
                      label="Dátum nástupu"
                      value={zakladovaDoskaDate}
                      onChange={(e) => setZakladovaDoskaDate(e)}
                      format="DD/MM/YYYY"
                    />
                    <DatePicker
                      label="Dátum ukončenia"
                      value={zakladovaDoskaDateEnd}
                      onChange={(e) => setZakladovaDoskaDateEnd(e)}
                      format="DD/MM/YYYY"
                    />
                  </Grid>
                  <SearchSelect
                    sx={{ mt: 2, mb: 4, maxWidth: '300px' }}
                    value={idToPartia(zakladovaDoskaPartia)}
                    onChange={setZakladovaDoskaPartia}
                    options={existingPartie}
                    label="Partia"
                    id="partia1"
                    searchPlaceholder="Vyhľadajte kontaktnú osobu"
                  />
                  <Divider />
                  <Grid mt={3} mb={3}>
                    <Typography variant="h6" color="primary" mb={2}>
                      Hrubá stavba
                    </Typography>

                    <DatePicker
                      label="Dátum nástupu"
                      value={hrubovaStavbaDate}
                      onChange={(e) => setHrubovaStavbaDate(e)}
                      format="DD/MM/YYYY"
                    />
                    <DatePicker
                      label="Dátum ukončenia"
                      value={hrubovaStavbaDateEnd}
                      onChange={(e) => setHrubovaStavbaDateEnd(e)}
                      format="DD/MM/YYYY"
                    />
                  </Grid>
                  <SearchSelect
                    sx={{ mt: 2, mb: 4, maxWidth: '300px' }}
                    value={idToPartia(hrubaStavbaPartiaa)}
                    onChange={setHrubaStavbaPartiaa}
                    options={existingPartie}
                    label="Partia"
                    id="partia1"
                    searchPlaceholder="Vyhľadajte kontaktnú osobu"
                  />
                  <Divider />
                  <Grid mt={3} mb={3}>
                    <Typography variant="h6" color="primary" mb={2}>
                      Holodom
                    </Typography>
                    <DatePicker
                      label="Dátum nástupu"
                      value={holodomDate}
                      onChange={(e) => setHolodomDate(e)}
                      format="DD/MM/YYYY"
                    />
                    <DatePicker
                      label="Dátum ukončenia"
                      value={holodomDateEnd}
                      onChange={(e) => setHolodomDateEnd(e)}
                      format="DD/MM/YYYY"
                    />
                  </Grid>
                  <SearchSelect
                    sx={{ mt: 2, mb: 4, maxWidth: '300px' }}
                    value={idToPartia(holodomPartiaa)}
                    onChange={setHolodomPartiaa}
                    options={existingPartie}
                    label="Partia"
                    id="partia1"
                    searchPlaceholder="Vyhľadajte kontaktnú osobu"
                  />
                  <Grid mt={3} mb={3}>
                    <Typography variant="h6" color="primary" mb={2}>
                      Dátum montáže okien
                    </Typography>
                    <DatePicker
                      label="Dátum nástupu"
                      value={oknaDate}
                      onChange={(e) => setOknaDate(e)}
                      format="DD/MM/YYYY"
                    />
                    <DatePicker
                      label="Dátum ukončenia"
                      value={oknaDateEnd}
                      onChange={(e) => setOknaDateEnd(e)}
                      format="DD/MM/YYYY"
                    />
                  </Grid>
                  <Divider />
                  <Grid mt={3} mb={3}>
                    <Typography variant="h6" color="primary" mb={2}>
                      Dom na kľúč
                    </Typography>
                    <DatePicker
                      label="Dátum nástupu"
                      value={domNaKlucDate}
                      onChange={(e) => setDomNaKlucDate(e)}
                      format="DD/MM/YYYY"
                    />
                    <DatePicker
                      label="Dátum ukončenia"
                      value={domNaKlucDateEnd}
                      onChange={(e) => setDomNaKlucDateEnd(e)}
                      format="DD/MM/YYYY"
                    />
                  </Grid>
                  <SearchSelect
                    sx={{ mt: 2, mb: 4, maxWidth: '300px' }}
                    value={idToPartia(naKlucPartia)}
                    onChange={setNaKlucPartia}
                    options={existingPartie}
                    label="Partia"
                    id="partia1"
                    searchPlaceholder="Vyhľadajte kontaktnú osobu"
                  />
                  <Button variant="contained" size="large" onClick={handleSubmit(submitEditZakazka)}>
                    Uložiť zmeny
                  </Button>
                </>
              )}
            </SectionAccordionContent>
          </SectionAccordion>
        </Card>

        <Card sx={{ p: 1, mt: 2, mb: 2 }}>
          <SectionAccordion>
            <SectionAccordionTitle>
              <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: 1 }}>
                <HandymanRoundedIcon sx={{ fontSize: 30 }} />
                <Typography variant="h4">Stavebné materiály a detaily stavby</Typography>
              </Box>
            </SectionAccordionTitle>
            <SectionAccordionContent>
              <>
                <Typography variant="h4" color="primary" mb={2}>
                  Komín
                </Typography>
                <HTMLEditor value={fieldValues.komin} onChange={(e) => onFieldValueChange('komin', e)} />
                <Typography variant="h4" color="primary" mt={2} mb={2}>
                  Škridla
                </Typography>
                <HTMLEditor
                  defaultValue={zakazka?.skridla}
                  value={fieldValues.skridla}
                  onChange={(e) => onFieldValueChange('skridla', e)}
                />
                <Typography variant="h4" color="primary" mt={2} mb={2}>
                  Hydroizolácia
                </Typography>
                <HTMLEditor
                  defaultValue={zakazka?.hydroizolacia}
                  value={fieldValues.hydroizolacia}
                  onChange={(e) => onFieldValueChange('hydroizolacia', e)}
                />
                <Typography variant="h4" color="primary" mt={2} mb={2}>
                  Rošt
                </Typography>
                <HTMLEditor
                  defaultValue={zakazka?.rost}
                  value={fieldValues.rost}
                  onChange={(e) => onFieldValueChange('rost', e)}
                />
                <Typography variant="h4" color="primary" mt={2} mb={2}>
                  Pochôdzna povala
                </Typography>
                <HTMLEditor
                  defaultValue={zakazka?.povala}
                  value={fieldValues.povala}
                  onChange={(e) => onFieldValueChange('povala', e)}
                />
                <Typography variant="h4" color="primary" mt={2} mb={2}>
                  Okná
                </Typography>
                <HTMLEditor
                  value={fieldValues.okna}
                  onChange={(e) => onFieldValueChange('okna', e)}
                  defaultValue={zakazka?.okna}
                />
                <Typography variant="h4" color="primary" mt={2} mb={2}>
                  Zateplenie ZD
                </Typography>
                <HTMLEditor
                  defaultValue={zakazka?.zateplenie}
                  value={fieldValues.zateplenie}
                  onChange={(e) => onFieldValueChange('zateplenie', e)}
                />
                <Typography variant="h4" color="primary" mt={2} mb={2}>
                  Vchodové dvere
                </Typography>
                <HTMLEditor
                  defaultValue={zakazka?.dvere}
                  value={fieldValues.dvere}
                  onChange={(e) => onFieldValueChange('dvere', e)}
                />
                <Typography variant="h4" color="primary" mt={2} mb={2}>
                  Bojler
                </Typography>
                <HTMLEditor
                  defaultValue={zakazka?.bojler}
                  value={fieldValues.bojler}
                  onChange={(e) => onFieldValueChange('bojler', e)}
                />
                <Typography variant="h4" color="primary" mt={2} mb={2}>
                  Vykurovanie
                </Typography>
                <HTMLEditor
                  defaultValue={zakazka?.vykurovanie}
                  value={fieldValues.vykurovanie}
                  onChange={(e) => onFieldValueChange('vykurovanie', e)}
                />
                <Typography variant="h4" color="primary" mt={2} mb={2}>
                  Rekuperácia
                </Typography>
                <HTMLEditor
                  defaultValue={zakazka?.rekuperacia}
                  value={fieldValues.rekuperacia}
                  onChange={(e) => onFieldValueChange('rekuperacia', e)}
                />
                <Typography variant="h4" color="primary" mt={2} mb={2}>
                  Prístup na stavbu
                </Typography>
                <HTMLEditor
                  defaultValue={zakazka?.pristup}
                  value={fieldValues.pristup}
                  onChange={(e) => onFieldValueChange('pristup', e)}
                />
                <Button variant="contained" size="large" sx={{ mt: 2 }} onClick={handleSubmit(submitEditZakazka)}>
                  Uložiť zmeny
                </Button>
              </>
            </SectionAccordionContent>
          </SectionAccordion>
        </Card>
        <Card sx={{ p: 1, mt: 2, mb: 2 }}>
          <SectionAccordion>
            <SectionAccordionTitle>
              <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: 1 }}>
                <BlindsClosedIcon sx={{ fontSize: 30 }} />
                <Typography variant="h4">Exterierové žalúzie</Typography>
                <StyledSwitch checked={zaluzieSwitch} onChange={zaluzieSwitchHandler} name="zaluzie" />
              </Box>
            </SectionAccordionTitle>
            <SectionAccordionContent>
              {zaluzieSwitch ? (
                <>
                  <ZaluzieWrapper columns="4">
                    <TextField
                      id="fazyRealizacie"
                      label="Fázy realizácie"
                      variant="outlined"
                      defaultValue={zakazka?.zaluzieFazy}
                      {...register('zaluzieFazy')}
                    />
                    <TextField
                      id="sposobOvladania"
                      label="Spôsob ovládania"
                      variant="outlined"
                      defaultValue={zakazka?.zaluzieSposob}
                      {...register('zaluzieSposob')}
                    />
                    <TextField
                      id="mnozstvo"
                      label="Množstvo"
                      defaultValue={zakazka?.zaluzieMnozstvo}
                      variant="outlined"
                      {...register('zaluzieMnozstvo')}
                    />
                    <TextField
                      id="umiestnenie"
                      label="Umiestnenie"
                      variant="outlined"
                      defaultValue={zakazka?.zaluzieUmiestnenie}
                      {...register('zaluzieUmiestnenie')}
                    />
                  </ZaluzieWrapper>
                  <ZaluzieWrapper columns="3">
                    <DatePicker
                      label="Termín objednania"
                      value={zaluzieObjednanieDate}
                      onChange={(e) => setZaluzieObjednanieDate(e)}
                      format="DD/MM/YYYY"
                    />
                    <DatePicker
                      label="Termín zamerania"
                      value={zaluzieZamerianieDate}
                      onChange={(e) => setZaluzieZamerianieDate(e)}
                      format="DD/MM/YYYY"
                    />
                    <DatePicker
                      label="Termín montáže"
                      value={zaluzieMontazDate}
                      onChange={setZaluzieMontazDate}
                      format="DD/MM/YYYY"
                    />
                  </ZaluzieWrapper>
                  <HTMLEditor
                    style={{ marginTop: 20 }}
                    value={fieldValues.zaluziePoznamky}
                    onChange={(e) => onFieldValueChange('zaluziePoznamky', e)}
                  />
                  <Button variant="contained" size="large" sx={{ mt: 2 }} onClick={handleSubmit(submitEditZakazka)}>
                    Uložiť zmeny
                  </Button>
                </>
              ) : (
                <>Táto možnosť je vypnutá</>
              )}
            </SectionAccordionContent>
          </SectionAccordion>
        </Card>
        <Card sx={{ p: 1, mt: 2, mb: 2 }}>
          <SectionAccordion>
            <SectionAccordionTitle>
              <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: 1 }}>
                <SolarPowerOutlinedIcon sx={{ fontSize: 30 }} />
                <Typography variant="h4">Fotovoltika</Typography>
                <StyledSwitch checked={fotovoltikaSwitch} onChange={fotovoltikaSwitchHandler} name="zaluzie" />
              </Box>
            </SectionAccordionTitle>
            <SectionAccordionContent>
              {fotovoltikaSwitch ? (
                <>
                  <ZaluzieWrapper columns="2">
                    <Box>
                      <Typography variant="h5" color="text.secondary" mb={3}>
                        Informácie
                      </Typography>
                      <TextField
                        label="Fotovoltika Typ"
                        variant="outlined"
                        sx={{ marginTop: 2, width: '100%' }}
                        defaultValue={zakazka?.fotovoltikaTyp}
                        {...register('fotovoltikaTyp')}
                      />
                      <TextField
                        label="Suma - poznámka"
                        variant="outlined"
                        sx={{ marginTop: 2, width: '100%' }}
                        defaultValue={zakazka?.fotovoltikaSuma}
                        {...register('fotovoltikaSuma')}
                      />
                      <TextField
                        sx={{ mt: 2, width: '100%' }}
                        defaultValue={zakazka?.contactPerson}
                        value={contactPerson}
                        onChange={(e) => setContactPerson(e.target.value)}
                        label="Kontaktná osoba"
                      />
                    </Box>
                    <Box>
                      <Typography variant="h5" color="text.secondary" mb={3}>
                        Termíny
                      </Typography>
                      <DatePicker
                        label="Hrubá stavba"
                        mb={3}
                        sx={{ width: '100%' }}
                        value={hrubovaStavbaDate}
                        onChange={(e) => setHrubovaStavbaDate(e)}
                        format="DD/MM/YYYY"
                      />

                      <SearchSelect
                        sx={{ mt: 2, mb: 4 }}
                        value={idToPartia(hrubaStavbaPartia)}
                        onChange={setHrubaStavbaPartia}
                        options={existingPartie}
                        label="Partia"
                        id="partia1"
                        searchPlaceholder="Vyhľadajte kontaktnú osobu"
                      />

                      <DatePicker
                        label="Holodom stavba"
                        mb={3}
                        sx={{ width: '100%' }}
                        value={holodomDate}
                        onChange={(e) => setHolodomDate(e)}
                        format="DD/MM/YYYY"
                      />

                      <SearchSelect
                        sx={{ mt: 2, mb: 4 }}
                        value={idToPartia(holodomPartiaa)}
                        onChange={setHolodomPartiaa}
                        options={existingPartie}
                        label="Partia"
                        id="partia1"
                        searchPlaceholder="Vyhľadajte kontaktnú osobu"
                      />
                    </Box>
                  </ZaluzieWrapper>
                  <Button variant="contained" size="large" sx={{ mt: 2 }} onClick={handleSubmit(submitEditZakazka)}>
                    Uložiť zmeny
                  </Button>
                </>
              ) : (
                <>Táto možnosť je vypnutá</>
              )}
            </SectionAccordionContent>
          </SectionAccordion>
        </Card>
        <Card sx={{ p: 1, mt: 2, mb: 2 }}>
          <SectionAccordion isExpanded={true}>
            <SectionAccordionTitle>
              <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: 1 }}>
                <AttachFileRoundedIcon sx={{ fontSize: 30 }} />
                <Typography variant="h4">Prílohy a súbory</Typography>
              </Box>
            </SectionAccordionTitle>
            <SectionAccordionContent>
              {(zakazka && zakazka.files?.length > 0) || (files && files?.length > 0) ? (
                <TableContainer sx={{ mb: 3 }}>
                  <Table>
                    <TableHead>
                      <TableRow>
                        <TableCell>Názov súboru</TableCell>
                        <TableCell>Stiahnuť</TableCell>
                        <TableCell>Vymazať</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {zakazka.files.map((file, index) => (
                        <TableRow key={index}>
                          <TableCell>{file?.name}</TableCell>
                          <TableCell>
                            <IconButton
                              aria-label="delete"
                              color="success"
                              onClick={() => handleDownloadFile(file.path)}
                            >
                              <DownloadOutlined />
                            </IconButton>
                          </TableCell>
                          <TableCell>
                            <IconButton
                              aria-label="delete"
                              color="error"
                              onClick={() => handleRemoveFileDatabase(file.id)}
                            >
                              <DeleteOutlineOutlined />
                            </IconButton>
                          </TableCell>
                        </TableRow>
                      ))}
                      {files &&
                        files.map((file, index) => (
                          <TableRow key={index}>
                            <TableCell>{file?.name}</TableCell>
                            <TableCell></TableCell>
                            <TableCell>
                              <IconButton aria-label="delete" color="error" onClick={() => handleRemoveFile(file)}>
                                <DeleteOutlineOutlined />
                              </IconButton>
                            </TableCell>
                          </TableRow>
                        ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              ) : (
                <Typography
                  variant="h5"
                  sx={{
                    width: '100%',
                    textAlign: 'center',
                    py: 3,
                  }}
                >
                  Nemáte nahrané žiadne súbory.
                </Typography>
              )}
              <div>
                <Box
                  sx={{
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    gap: 1,
                    justifyContent: 'space-between',
                  }}
                >
                  <Button type="file" variant="outlined" size="large" component="label">
                    <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: 1 }}>
                      {' '}
                      <CloudUploadRounded />
                      Pridať súbor
                    </Box>
                    <input hidden type="file" value={''} multiple onChange={handleFileChange} />
                  </Button>
                  <Button variant="contained" size="large" onClick={handleSaveFiles}>
                    <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: 1 }}>
                      Uložiť súbory
                    </Box>
                  </Button>
                </Box>
              </div>
            </SectionAccordionContent>
          </SectionAccordion>
        </Card>
      </Container>
      <Modal
        aria-labelledby="modal-title"
        aria-describedby="modal-desc"
        open={openPicker}
        onClose={() => setOpenPicker(false)}
        sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}
      >
        <ModalBody>
          <PositionPicker
            position={{ lat: 49.201614395271974, lng: 21.652639645246314 }}
            setMarkerPosition={setMapPosition}
            setLat={setLat}
            setLng={setLng}
            markerPosition={mapPosition}
          />

          <Button
            variant="outlined"
            onClick={() => {
              setOpenPicker(false);
            }}
          >
            Zvoliť polohu
          </Button>
        </ModalBody>
      </Modal>
    </>
  );
};

export default ZakazkyDetail;
